// src/components/AuthCard.jsx
// ============================================================
// Envoltorio visual de las pantallas sueltas de autenticación (recuperación
// de contraseña). Fondo oscuro con la tarjeta centrada, igual que la card de
// login de LandingPage, para que el flujo se lea como continuación de ella y
// no como otra aplicación.
//
// Existe para no triplicar el mismo layout en las tres pantallas del flujo.
// ============================================================

import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../assets/images/logo.png';

export default function AuthCard({ titulo, subtitulo, children }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#163244',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 6,
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 420 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <RouterLink to="/">
            <Box
              component="img"
              src={logo}
              alt="Fixo"
              sx={{ width: 110, height: 110, borderRadius: 3, objectFit: 'contain' }}
            />
          </RouterLink>
        </Box>

        <Box
          sx={{
            bgcolor: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 3,
            p: { xs: 3, sm: 4 },
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 600,
              fontSize: 20,
              color: '#fff',
              textAlign: 'center',
              mb: 1,
            }}
          >
            {titulo}
          </Typography>

          {subtitulo && (
            <Typography
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 14,
                color: 'rgba(255,255,255,0.65)',
                textAlign: 'center',
                mb: 3,
                lineHeight: 1.6,
              }}
            >
              {subtitulo}
            </Typography>
          )}

          {children}
        </Box>
      </Box>
    </Box>
  );
}
